"use client";
import { usePathname } from "next/navigation";
import { useRouter } from "next13-progressbar";
import { SearchIcon } from "./searchIcon";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

export const SearchField = ({
  searchParams,
  setSerchQuery,
  handleSearch,
  setSearchFieldOpen,
}: any) => {
  const pathName = usePathname();
  const { replace } = useRouter();
  return (
    <div
      className={[
        "flex",
        "items-center",
        "justify-between",
        "w-full",
        "sm:px-8",
        "pl-4",
        "h-[72px]",
        "justify-between",
      ].join(" ")}
    >
      <input
        data-testid={applyDataTestId(pom.header.searchInputField)}
        className={[
          "w-full",
          "my-4",
          "px-12",
          "py-2",
          "border",
          "rounded-lg",
          "focus:outline-none",
          "focus:ring-1",
          "focus:ring-black",
          "text-[16px]",
        ].join(" ")}
        defaultValue={searchParams.get("query")?.toString()}
        onChange={(e) => {
          setSerchQuery(e.target.value);
        }}
        onKeyDown={handleSearch}
      />
      <button
        onClick={() => {
          setSearchFieldOpen(false);
          const params = new URLSearchParams(searchParams);
          params.delete("query");
          replace(`${pathName}?${params.toString()}`);
        }}
        className="absolute right-8 sm:right-16 text-2xl top-1/2 transform -translate-y-[55%] text-black focus:outline-none"
      >
        &times;
      </button>
      <div
        className={[
          "absolute",
          "pl-3",
          "sm:pl-5",
          "top-1/2",
          "transform",
          "-translate-y-1/2",
          "text-black",
          "focus:outline-nonecursor-pointer",
        ].join(" ")}
      >
        <SearchIcon />
      </div>
    </div>
  );
};
